import { useEffect, useRef, useState } from "react";

// Defers rendering of below-the-fold sections until the user scrolls near them,
// so their scripts and network requests do not compete with the catalog above.
const LazySection = ({ children, rootMargin = "200px", minHeight = 200 }) => {
  const placeholderRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) return undefined;

    // Non-browser environments (tests, prerender) get the content directly.
    if (typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return undefined;
    }

    const node = placeholderRef.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(node);

    return () => observer.disconnect();
  }, [isVisible, rootMargin]);

  if (isVisible) {
    return children;
  }

  return <div ref={placeholderRef} style={{ minHeight }} aria-hidden="true" />;
};

export default LazySection;
